import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useSendConfirmationPresence = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: sendConfirmationPresence,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['events', 'next'] }),
  });
};

const sendConfirmationPresence = async (uuid: string) =>
  api.put(apiConfig.routes.events.confirmPresence(uuid));
